import { create } from "zustand";
import { HostClientType } from "@microsoft/teams-js";
import { TeamsContextState, TeamsContextActions } from "./types";

export const useTeamsContextStore = create<
	TeamsContextState & TeamsContextActions
>((set) => ({
	hostClientType: undefined,
	setHostClientType: (hostClientType: HostClientType) =>
		set({ hostClientType: hostClientType }),
}));
